import { motion, MotionValue } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type FlashcardSwipeFeedbackProps = {
  successOpacity?: MotionValue<number>;
  errorOpacity?: MotionValue<number>;
};

export function FlashcardSwipeResultLabel({
  successOpacity,
  errorOpacity,
}: FlashcardSwipeFeedbackProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.flashcard',
  });
  return (
    <div className="relative flex h-8 items-center justify-center">
      <motion.span
        style={{ opacity: successOpacity }}
        className="absolute text-xl font-semibold text-success"
      >
        {t('true')}!
      </motion.span>
      <motion.span
        style={{ opacity: errorOpacity }}
        className="absolute text-xl font-semibold text-error"
      >
        {t('false')}!
      </motion.span>
    </div>
  );
}

export function FlashcardSwipeColorOverlay({
  successOpacity,
  errorOpacity,
}: FlashcardSwipeFeedbackProps) {
  const swipeOverlayClass = 'pointer-events-none absolute inset-0 rounded-2xl';

  return (
    <>
      <motion.div
        style={{ opacity: successOpacity }}
        className={twMerge(swipeOverlayClass, 'bg-success-content z-0')}
      />
      <motion.div
        style={{ opacity: errorOpacity }}
        className={twMerge(swipeOverlayClass, 'bg-error-content z-0')}
      />
    </>
  );
}
